<template>
 <div>
     <highcharts :options="chartOptions"></highcharts>
 </div>
</template>

<script>
  export default {
    name: 'PlayerSeasonHoleChart',
    props: ['player', 'season'],
    data() {
      return {
        chartOptions: {
          chart: {
            type: 'area',
            height: 250
          },
          title: '',
          credits: {
            enable: false
          },
          plotOptions: {
            area: {
              fillOpacity: .2
            }
          },
          tooltip: {
            shared: true
          },
          xAxis : {
            categories: []
          },
          yAxis:[{ title: ''}, { title: ''}],
          series: []
        }
      }
    },
    methods: {
      updateChartData () {
        let chartData =  {
          categories: [],
          series: [
            {
              name: 'Season Avg',
              data: [],
              color: '#777'
            }, {
              name: 'Player Avg',
              data: []
            }
          ]
        };
        chartData = this.player.reduce((result, item, idx) => {
          const season = this.season[idx];
          result.categories.push('Hole ' + item.hole);
          result.series[1].data.push(parseFloat(item.average.toFixed(2)));
          result.series[0].data.push(parseFloat(season.average.toFixed(2)));
          return result;
        }, chartData);

        this.chartOptions.series =  chartData.series;
        this.chartOptions.xAxis.categories = chartData.categories;
      }
    },
    watch: {
      'player': 'updateChartData'
    },
    created () {
      this.updateChartData()
    }
  }
</script>

<style scoped>

</style>
